// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 220px;
  min-width: 220px;
  flex-shrink: 0;
  background-color: #2C3E50;
  padding: 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}


.sidebar-section {
  margin-bottom: 20px;
}

.sidebar-title {
  color: #ECF0F1;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #34495E;
}

.library-subsection {
  margin-bottom: 12px;
}

.add-template-btn {
  width: 100%;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 8px;
  transition: background-color 0.2s;
}

.add-person-btn {
  background-color: #E74C3C;
}

.add-person-btn:hover {
  background-color: #C0392B;
}

.add-entity-btn {
  background-color: #F39C12;
}

.add-entity-btn:hover {
  background-color: #D68910;
}

.add-template-btn:disabled {
  background-color: #95A5A6;
  cursor: not-allowed;
}

.template-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.template-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: grab;
  font-size: 12px;
  transition: background-color 0.2s, transform 0.1s;
}

.template-individual {
  background-color: #FF6F61;
}

.template-individual:hover {
  background-color: #E55A4E;
  transform: translateX(2px);
}

.template-entity {
  background-color: #FFD700;
  color: #2C3E50;
}

.template-entity:hover {
  background-color: #E6C200;
  transform: translateX(2px);
}

.template-item:active {
  cursor: grabbing;
}

.template-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
}

.template-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}

.template-incomes-badge {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  gap: 4px;
}

.template-incomes-badge::before {
  content: "💰";
  font-size: 9px;
}

.template-badge {
  font-size: 10px;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 2px 4px;
  border-radius: 3px;
}

.template-actions {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: 6px;
}

.edit-template-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  cursor: pointer;
  padding: 2px 4px;
  line-height: 1;
}

.template-entity .edit-template-btn {
  color: rgba(44, 62, 80, 0.6);
}

.edit-template-btn:hover {
  color: white;
}

.template-entity .edit-template-btn:hover {
  color: #2C3E50;
}

.delete-template-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}

.template-entity .delete-template-btn {
  color: rgba(44, 62, 80, 0.6);
}

.delete-template-btn:hover {
  color: white;
}

.template-entity .delete-template-btn:hover {
  color: #2C3E50;
}

.empty-library {
  color: #7F8C8D;
  font-size: 12px;
  text-align: center;
  padding: 10px;
  font-style: italic;
}

.add-lane {
  background-color: #3498DB;
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: auto;
  border-radius: 5px;
}

.add-lane:hover {
  background-color: #2980B9;
}

/* Modal select styling */
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #BDC3C7;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  background-color: white;
}

.form-group select:focus {
  outline: none;
  border-color: #3498DB;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.save-btn-entity {
  background-color: #F39C12;
}

.save-btn-entity:hover {
  background-color: #D68910;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sidebar {\n  width: 220px;\n  min-width: 220px;\n  flex-shrink: 0;\n  background-color: #2C3E50;\n  padding: 15px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n\n.sidebar-section {\n  margin-bottom: 20px;\n}\n\n.sidebar-title {\n  color: #ECF0F1;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 0 0 10px 0;\n  padding-bottom: 5px;\n  border-bottom: 1px solid #34495E;\n}\n\n.library-subsection {\n  margin-bottom: 12px;\n}\n\n.add-template-btn {\n  width: 100%;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 12px;\n  margin-bottom: 8px;\n  transition: background-color 0.2s;\n}\n\n.add-person-btn {\n  background-color: #E74C3C;\n}\n\n.add-person-btn:hover {\n  background-color: #C0392B;\n}\n\n.add-entity-btn {\n  background-color: #F39C12;\n}\n\n.add-entity-btn:hover {\n  background-color: #D68910;\n}\n\n.add-template-btn:disabled {\n  background-color: #95A5A6;\n  cursor: not-allowed;\n}\n\n.template-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.template-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: white;\n  padding: 6px 8px;\n  border-radius: 4px;\n  cursor: grab;\n  font-size: 12px;\n  transition: background-color 0.2s, transform 0.1s;\n}\n\n.template-individual {\n  background-color: #FF6F61;\n}\n\n.template-individual:hover {\n  background-color: #E55A4E;\n  transform: translateX(2px);\n}\n\n.template-entity {\n  background-color: #FFD700;\n  color: #2C3E50;\n}\n\n.template-entity:hover {\n  background-color: #E6C200;\n  transform: translateX(2px);\n}\n\n.template-item:active {\n  cursor: grabbing;\n}\n\n.template-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n}\n\n.template-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.template-incomes-badge {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.template-incomes-badge::before {\n  content: \"💰\";\n  font-size: 9px;\n}\n\n.template-badge {\n  font-size: 10px;\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n\n.template-actions {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: 6px;\n}\n\n.edit-template-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  cursor: pointer;\n  padding: 2px 4px;\n  line-height: 1;\n}\n\n.template-entity .edit-template-btn {\n  color: rgba(44, 62, 80, 0.6);\n}\n\n.edit-template-btn:hover {\n  color: white;\n}\n\n.template-entity .edit-template-btn:hover {\n  color: #2C3E50;\n}\n\n.delete-template-btn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0 4px;\n  line-height: 1;\n}\n\n.template-entity .delete-template-btn {\n  color: rgba(44, 62, 80, 0.6);\n}\n\n.delete-template-btn:hover {\n  color: white;\n}\n\n.template-entity .delete-template-btn:hover {\n  color: #2C3E50;\n}\n\n.empty-library {\n  color: #7F8C8D;\n  font-size: 12px;\n  text-align: center;\n  padding: 10px;\n  font-style: italic;\n}\n\n.add-lane {\n  background-color: #3498DB;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  margin-top: auto;\n  border-radius: 5px;\n}\n\n.add-lane:hover {\n  background-color: #2980B9;\n}\n\n/* Modal select styling */\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #BDC3C7;\n  border-radius: 4px;\n  font-size: 14px;\n  box-sizing: border-box;\n  background-color: white;\n}\n\n.form-group select:focus {\n  outline: none;\n  border-color: #3498DB;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.save-btn-entity {\n  background-color: #F39C12;\n}\n\n.save-btn-entity:hover {\n  background-color: #D68910;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
